// extracted by mini-css-extract-plugin
export default {"container":"LoadingStatusPanel_container__ePQwk","content":"LoadingStatusPanel_content__mXc2z"};